import {Injectable} from '@angular/core';
import {ListEntry} from '@app/shared/list/list.component';
import {Kontakt} from '@pezi/entities';

@Injectable()
export class FilterUtil {

  private static WEIGHT_NACHNAME_STARTSWITH = 5;
  private static WEIGHT_VORNAME_STARTSWITH = 4;
  private static WEIGHT_NAME = 3;
  private static WEIGHT_ABTEILUNG = 1;
  private static WEIGHT_KB = 1;
  private static WEIGHT_TELEFON = 1;

  public static filterKontakte(searchstr: string, kontakte: ListEntry<Kontakt>[]): ListEntry<Kontakt>[] {
    if (searchstr) {
      const lcSearch = searchstr.toLowerCase()
        .trim();
      const splitted = lcSearch.split(' ');
      const generalFiltered = kontakte.map(val => {
        const fullName = val.data.vorname ? val.data.vorname + ' ' + val.data.nachname : val.data.nachname;
        const abteilung = val.data.abteilung ? val.data.abteilung : '';
        const kb = val.data.kundenbuero ? val.data.kundenbuero : '';
        const fest = val.data.fest ? val.data.fest : '';
        let weight = 0;
        splitted.forEach(part => {
          if (this.extraWurstFilter(val.data, part)) {
            weight += this.calculateKontakteWeight(fullName, abteilung, kb, fest, part, val)
          }
        });
        return {
          data: val,
          weight
        };
      })
        .filter(kontaktWithWeight => kontaktWithWeight.weight > 0)
        .sort((a, b) => b.weight - a.weight)
        .map(kontaktWithWeight => kontaktWithWeight.data);
      kontakte = [
        ...generalFiltered
      ];
    }
    return kontakte;
  }

  public static filterName(searchstr: string, nachname: string, vorname?: string): boolean {
    if (searchstr) {
      const lcSearch = searchstr.toLowerCase()
        .trim();
      const splitted = lcSearch.split(' ');
      const reversedName = vorname ? nachname + ' ' + vorname : nachname;
      const fullName = vorname ? vorname + ' ' + nachname : nachname;
      let result = true;
      splitted.forEach(part => {
        result = fullName.trim()
          .toLowerCase()
          .indexOf(part) !== -1 || reversedName.trim()
          .toLowerCase()
          .indexOf(part) !== -1;
      });
      return result;
    }
    return false;
  }

  private static extraWurstFilter(kontakt: Kontakt, search: string): boolean {
    if (kontakt.nachname === 'Pfaffeneder' && !search.startsWith('pfaffe') && !search.startsWith('joha')) {
      return false;
    }
    // add more special cases here if needed
    return true;
  }

  private static calculateKontakteWeight(fullName: string, abteilung: string, kb: string, fest: string, part: string, entry: ListEntry<Kontakt>): number {
    let weight = 0;
    const foundInName = fullName.trim()
      .toLowerCase()
      .indexOf(part) !== -1;
    if (foundInName) {
      if (entry?.data?.vorname?.toLowerCase()
        .startsWith(part)) {
        weight += this.WEIGHT_VORNAME_STARTSWITH;
      } else if (entry?.data?.nachname?.toLowerCase()
        .startsWith(part)) {
        weight += this.WEIGHT_NACHNAME_STARTSWITH;
      } else {
        weight += this.WEIGHT_NAME;
      }
    }
    if (abteilung.trim()
      .toLowerCase()
      .indexOf(part) !== -1) {
      weight += this.WEIGHT_ABTEILUNG;
    }
    if (kb.trim()
      .toLowerCase()
      .indexOf(part) !== -1) {
      weight += this.WEIGHT_KB;
    }

    if (part.length > 2) {  // Nur wenn mehr als 2 Zahlen angegeben Telefonnummern durchsuchen
      if (fest.trim()
        .toLowerCase()
        .indexOf(part) !== -1) {
        weight += this.WEIGHT_TELEFON;
      }
    }
    return weight;
  }
}
